import type { MenuItem } from '@openng/optimus-ui/api';

/**
 * Ikony akcí (@openng/icons) v kontextových menu řádků (ui-context-menu) i na tlačítkách akcí v detailech. Stejná akce
 * má na všech obrazovkách stejnou ikonu; nová položka menu nebo tlačítko akce bere ikonu odsud.
 */
export const IKONY_AKCI = {
  detail: 'pi pi-eye',
  editace: 'pi pi-pencil',
  editovatPlatnost: 'pi pi-calendar',
  smazat: 'pi pi-trash',
  archivovat: 'pi pi-box',
  zneplatnit: 'pi pi-ban',
  ukoncit: 'pi pi-calendar-times',
  novaVerze: 'pi pi-file-plus',
  kopie: 'pi pi-copy',
  publikovat: 'pi pi-globe',
  vratit: 'pi pi-undo',
  predschvalit: 'pi pi-check',
  schvalit: 'pi pi-check-circle',
  zamitnout: 'pi pi-times-circle',
  vyjadreni: 'pi pi-comment',
  stahnoutPdf: 'pi pi-download',
  nahratDokumentaci: 'pi pi-upload',
  pridatResitele: 'pi pi-user-plus',
  zahajitReseni: 'pi pi-play-circle',
  dokoncitReseni: 'pi pi-check-square',
  zpochybnit: 'pi pi-pen-to-square',
  reklamovat: 'pi pi-flag',
  odeslat: 'pi pi-send',
  vytvorit: 'pi pi-plus',
  neznama: 'pi pi-question-circle',
} as const;

/** Položka kontextového menu řádku: ikona je povinná (IKONY_AKCI), menu bez ikon kompilátor nepustí. */
export type AkceMenuItem = MenuItem & { icon: string };
